import { render, staticRenderFns } from "./scb.vue?vue&type=template&id=21a1cd6e&scoped=true&"
import script from "./scb.vue?vue&type=script&lang=js&"
export * from "./scb.vue?vue&type=script&lang=js&"
import style0 from "./scb.vue?vue&type=style&index=0&id=21a1cd6e&scoped=true&lang=css&"
import style1 from "./scb.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1cd6e",
  null
  
)

export default component.exports